var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"eqs-main-container margin-auto"},[_c('GlobalFinalState',_vm._b({scopedSlots:_vm._u([{key:"content",fn:function(){return [_c('EqsTextDisplay',_vm._b({staticClass:"text-center",attrs:{"eqs-type":"subtitle"}},'EqsTextDisplay',{ elClass: 'success-txt' },false),[_c('span',{domProps:{"innerHTML":_vm._s(_vm.successTxt)}})])]},proxy:true}])},'GlobalFinalState',{
            loading: _vm.loading,
            state: _vm.state,
            errorText: _vm.errorText
        },false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }